<template functional>
  <div class="referred-job-info-item">
    <slot></slot>
    <span class="paragraph-s paragraph-dark-gray">{{ props.text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {type: String}
  }
};
</script>

<style lang="scss">
.referred-job-info-item {
  padding-right: 25px;

  .svg-icon {
    position: relative;
    top: -1px;
    left: -3px;
    margin-right: 5px;
    color: var(--secondary);
  }

  span {
    font-weight: initial;
  }
}
</style>
